var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.44152 3.11794H3.9103C3.40756 3.11794 3 3.527 3 4.03161V20.1142C3 20.6188 3.40756 21.0279 3.9103 21.0279H6.44152C6.94427 21.0279 7.35182 20.6188 7.35182 20.1142V4.03161C7.35182 3.527 6.94427 3.11794 6.44152 3.11794Z",
    stroke: "var(--sidebar-text-color)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.02818H7.35182",
    stroke: "var(--sidebar-text-color)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 16.5244H7.35182",
    stroke: "var(--sidebar-text-color)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5015 3.32476L8.13559 4.22777C7.66567 4.40713 7.42959 4.93488 7.60828 5.40653L13.3035 20.439C13.4822 20.9106 14.008 21.1476 14.4779 20.9682L16.8438 20.0652C17.3137 19.8859 17.5498 19.3581 17.3711 18.8865L11.6759 3.85402C11.4972 3.38236 10.9714 3.1454 10.5015 3.32476Z",
    stroke: "var(--sidebar-text-color)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02368 9.14227L13.0897 7.59001",
    stroke: "var(--sidebar-text-color)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0325 17.0844L16.0985 15.5321",
    stroke: "var(--sidebar-text-color)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2205 3.32486L12.8546 4.22788C12.3847 4.40723 12.1486 4.93498 12.3273 5.40664L18.0225 20.4391C18.2012 20.9108 18.727 21.1477 19.1969 20.9684L21.5628 20.0653C22.0327 19.886 22.2688 19.3582 22.0901 18.8866L16.3949 3.85413C16.2162 3.38247 15.6904 3.14551 15.2205 3.32486Z",
    stroke: "var(--sidebar-text-color)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7435 9.14229L17.8095 7.59003",
    stroke: "var(--sidebar-text-color)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7524 17.0844L20.8184 15.5321",
    stroke: "var(--sidebar-text-color)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBook);
export default __webpack_public_path__ + "static/media/ic-book.908ade3e0d607fe01fa4a18f3fa1a97f.svg";
export { ForwardRef as ReactComponent };